import { FC, memo } from 'react'
import { NodeProps, Position } from '@xyflow/react'
import CallSplitIcon from '@mui/icons-material/CallSplit'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import BaseNode from './BaseNode'
import { ConditionNodeData } from '../types'
import { xxllncColor } from '../../../layout/theme/color'

const ConditionNode: FC<NodeProps> = ({ id, data, selected }) => {
  const nodeData = data as ConditionNodeData

  return (
    <BaseNode
      nodeType="condition"
      icon={<CallSplitIcon fontSize="small" />}
      label={nodeData.label}
      nodeId={id}
      subtitle={nodeData.expression || 'Set condition...'}
      selected={selected}
      handles={[
        { type: 'target', position: Position.Top },
        {
          type: 'source',
          position: Position.Bottom,
          id: 'true',
          style: { left: '30%', background: xxllncColor.green100 },
        },
        {
          type: 'source',
          position: Position.Bottom,
          id: 'false',
          style: { left: '70%', background: xxllncColor.red100 },
        },
      ]}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 0.5 }}>
        <Typography variant="caption" sx={{ color: xxllncColor.green100, fontWeight: 600, fontSize: 10 }}>
          True
        </Typography>
        <Typography variant="caption" sx={{ color: xxllncColor.red100, fontWeight: 600, fontSize: 10 }}>
          False
        </Typography>
      </Box>
    </BaseNode>
  )
}

export default memo(ConditionNode)
